<template>
  <SogForm
    ref="_form"
  >
    <SogFormField>
      <SogTextBox
        v-model="_iban"
        placeholder="IBAN"
        name="IBAN"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_bic"
        placeholder="BIC"
        name="BIC"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_bank"
        placeholder="Bank"
        name="Bank"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import PersonDetails from "@/shared/model/personDetails";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
const _form = ref<InstanceType<typeof SogForm>  | null>(null)
interface Props {
  details?:PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const  props = withDefaults(defineProps<Props>(), {
  details:undefined
  })

const _iban = ref<string|undefined>(undefined)
const _bic = ref<string|undefined>(undefined)
const _bank = ref<string|undefined>(undefined)
function validate():boolean{
  return _form.value?.validate()??false;
}

watch(props,()=>{
  _iban.value = props.details?.getValue(PersonDetailsId.Iban)
  _bic.value = props.details?.getValue(PersonDetailsId.Bic)
  _bank.value = props.details?.getValue(PersonDetailsId.Bank)

},{immediate:true})

function getDetailsBank():PersonDetails|undefined{
  if(!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setValue(PersonDetailsId.Iban,_iban.value)
  details.setValue(PersonDetailsId.Bic,_bic.value)
  details.setValue(PersonDetailsId.Bank,_bank.value)
  return details;
}

defineExpose({
  validate,
  getDetailsBank
})
</script>

<style scoped>

</style>